// src/utils/tradingSession.js
export const isTradingSessionOpen = () => {
  const now = new Date();
  const day = now.getDay();
  const hours = now.getHours();
  const minutes = now.getMinutes();
  
  // Monday-Friday, 9:30 AM to 4:00 PM EST
  if (day >= 1 && day <= 5) {
    const estTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
    const estHours = estTime.getHours();
    const estMinutes = estTime.getMinutes();
    
    const isPreMarket = estHours < 9 || (estHours === 9 && estMinutes < 30);
    const isMarketHours = (estHours > 9 || (estHours === 9 && estMinutes >= 30)) && 
                         (estHours < 16 || (estHours === 16 && estMinutes === 0));
    const isAfterHours = estHours > 16 || (estHours === 16 && estMinutes > 0);
    
    return isMarketHours;
  }
  return false;
};

export const getTradingStatus = () => {
  return {
    isOpen: isTradingSessionOpen(),
//    nextOpen: getNextTradingSession(),
    lastUpdated: new Date().toISOString()
  };
};